export default __webpack_public_path__ + "static/media/logo.787715c2.svg";